/**
 * Homepage scene cards → already-filled configurator states.
 * Prices are quoted later from Shopify, using the same rules as the configurator.
 * Fixture SKUs must exist on that installation's shape list (basic / vibrant).
 */
(function (window) {
  'use strict';

  window.LEAVES_SCENE_PRESETS = [
    {
      id: 'tree',
      scene: 'tree',
      title: 'Outdoor wrap-around light',
      blurb: 'Wrap-around on a black 10 m cable, Basic model, with two CQA-HW-YQPC15-13W.',
      state: {
        v: 1,
        lightingMode: 'cw',
        installations: [
          {
            installationId: 'wrap_around',
            lengthMeters: 10,
            shapeId: 'basic',
            colorId: 'black',
            fixtures: {
              'CQA-HW-YQPC15-13W': 2,
            },
            trackId: '',
          },
        ],
      },
    },
    {
      id: 'pathway',
      scene: 'grass',
      title: 'Outdoor ground spike light',
      blurb: 'One black 10 m cable, Basic model, with four CQA-HW-YQPC12-10W.',
      state: {
        v: 1,
        lightingMode: 'cw',
        installations: [
          {
            installationId: 'ground_spike',
            lengthMeters: 10,
            shapeId: 'basic',
            colorId: 'black',
            fixtures: {
              'CQA-HW-YQPC12-10W': 4,
            },
            trackId: '',
          },
        ],
      },
    },
    {
      id: 'umbrella',
      scene: 'umbrella',
      title: 'Outdoor ceiling hanging light',
      blurb: 'Ceiling track on a black 10 m cable with LNT-HSC-W-9W, plus ceiling hanging on a black 10 m cable with CQA-PC-FB220-5.5W.',
      state: {
        v: 1,
        lightingMode: 'cw',
        installations: [
          {
            installationId: 'ceiling_track',
            lengthMeters: 10,
            shapeId: 'basic',
            colorId: 'black',
            fixtures: {
              'LNT-HSC-W-9W': 1,
            },
            trackId: '',
          },
          {
            installationId: 'ceiling_hanging',
            lengthMeters: 10,
            shapeId: 'basic',
            colorId: 'black',
            fixtures: {
              'CQA-PC-FB220-5.5W': 1,
            },
            trackId: '',
          },
        ],
      },
    },
    {
      id: 'wall-vibrant',
      scene: 'wall',
      title: 'Outdoor hanging light',
      blurb: 'Ceiling hanging on a black 10 m cable, Basic model, with two CQA-PC-D200-5.5W.',
      state: {
        v: 1,
        lightingMode: 'cw',
        installations: [
          {
            installationId: 'ceiling_hanging',
            lengthMeters: 10,
            shapeId: 'basic',
            colorId: 'black',
            fixtures: {
              'CQA-PC-D200-5.5W': 2,
            },
            trackId: '',
          },
        ],
      },
    },
    {
      id: 'pathway-ext',
      scene: 'grass',
      title: 'Outdoor ground spike light · 10 m',
      blurb: 'A longer ground-spike line on a black 10 m cable, Basic model, with three CQA-HW-YQPC12-10W.',
      state: {
        v: 1,
        lightingMode: 'cw',
        installations: [
          {
            installationId: 'ground_spike',
            lengthMeters: 10,
            shapeId: 'basic',
            colorId: 'black',
            fixtures: {
              'CQA-HW-YQPC12-10W': 3,
            },
            trackId: '',
          },
        ],
      },
    },
  ];
})(window);
